
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenderValidationService extends CrudService {

  constructor(public override http: HttpClient) {
    super('gender-validation', http);
  }

  /**
     * @author Dhaval Bera
     * @param formData
     */
  getAllGenderValidations(pageNo: any, sortField: string, sortOrder: string, globalFilter: string, rows: any, gender_filter: any, siteCodes: any) {

    let params: FormData = new FormData();
    if (!Number.isNaN(pageNo) && pageNo != null) {
      params.append("page", pageNo);
    }

    if (sortField !== undefined) {
      params.append("sortField", sortField);
      params.append("sortOrder", sortOrder);
    }

    if (globalFilter !== null && globalFilter !== undefined) {
      params.append("filters[global]", globalFilter);
    }
    if (gender_filter !== null && gender_filter !== undefined && gender_filter != '') {
      params.append("gender_filter", gender_filter);
    }
    if (siteCodes !== null && siteCodes !== undefined && siteCodes != '') {
      params.append("siteCodes", siteCodes);
    }

    if (rows !== 0) {
      params.append("perPage", rows);
    }
    return this.http.post(`${this.baseUrl}/list`, params)
      .pipe(catchError(this.handleError));
  }

  /**
   * This function is used to Make QC
   * @param id
   */
  getGenderValidationStatistics() {
    return this.http.get(this.baseUrl + '/get-statistics');
  }
  /**
  * This function is used to Make QC
  * @param formData
  */
  updateGenderValidationStatus(formData: any) {
    return this.http.post(this.baseUrl + '/update-status', formData);
  }

  /**
  * This function is used to Make QC
  * @param id
  */
  updateReviewed(participantIDs: any, validatedGenderStatus: any) {
    let params: FormData = new FormData();
    params.append("participant_id", participantIDs);
    params.append("validated_gender_status", validatedGenderStatus);

    return this.http.post(this.baseUrl + '/update-mark-as-reviewed', params);
  }
}
